// React
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"; // Keep if still used elsewhere, otherwise remove
import { Link, useNavigate, useParams } from "react-router-dom"; // Keep if still used elsewhere, otherwise remove

// External Packages
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookmark,
  faEnvelope,
  faPodcast, // Appears unused in JSX
} from "@fortawesome/free-solid-svg-icons";
import {
  faWhatsapp,
  faYoutube,
  faSpotify,
} from "@fortawesome/free-brands-svg-icons";

// Images
import wavy_bottom from "../../../images/Assets/PageBreakers/1920x100_Top.svg"; // Assuming this is correctly imported
import wavy_top from "../../../images/Assets/PageBreakers/1920x100_Bottom.svg"; // Appears unused in JSX

// Data Actions
import { listQuizes } from "../../../actions/quizActions"; // Keep if still used elsewhere, otherwise remove

// Components
import HowItWorksModal from "../../ui/HowItWorksModal/HowItWorksModal";

// Styles
import "./footer.css"; // Link to the new CSS file

const TestFooter = (props) => {
  const [darkMode, setDarkMode] = useState(false);
  const [showHowItWorks, setShowHowItWorks] = useState(false);

  // Consider using `useLayoutEffect` or a more robust way to get window size if needed
  // for initial render, or handle server-side rendering cases.
  const vw =
    typeof window !== "undefined"
      ? Math.max(
          document.documentElement.clientWidth || 0,
          window.innerWidth || 0,
        )
      : 0; // Default to 0 if window is not defined (SSR)

  const currentWindow =
    typeof window !== "undefined" ? window.location.href : ""; // Default to empty string if window is not defined (SSR)

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.location.href.includes("/tutorial")
    ) {
      setDarkMode(true);
    } else {
      setDarkMode(false);
    }
  }, []);

  const [userCount, setUserCount] = useState(0);
  const [userCountError, setUserCountError] = useState(false);

  useEffect(() => {
    const fetchUserCount = async () => {
      try {
        const response = await fetch(
          "https://api.nowasteddays.io/api/users/concurrent-users",
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setUserCount(data.activeUsers);
      } catch (error) {
        console.error("Failed to fetch user count:", error);
        setUserCountError(true);
      }
    };

    fetchUserCount();

    const intervalId = setInterval(fetchUserCount, 300000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      {showHowItWorks && (
        <HowItWorksModal
          mode="reference"
          onClose={() => setShowHowItWorks(false)}
        />
      )}
      {darkMode && (
        <img
          className="wave--top--footer"
          src={wavy_bottom}
          alt="wavy asset top"
          // width="100%" // Use CSS for width
        />
      )}
      <footer className={`test-footer ${darkMode ? "test-footer--dark" : ""}`}>
        <div className="footer-container">
          <div className="footer-row">
            <div className="footer-col">
              <h4 className="footer-heading">NoWastedDays</h4>
              <ul className="footer-list">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowHowItWorks(true);
                    }}
                  >
                    How NoWastedDays Works.
                  </a>
                </li>
                {currentWindow.endsWith("/") && (
                  <li>
                    <a href="/register">Get Started</a>
                  </li>
                )}
                {/* <li>
                  <a href="/about-nowasteddays">About NoWastedDays</a>
                </li> */}
                {/* <li>
                  <a href="/nowasteddays-commons">A Digital Commons Platform</a>
                </li> */}
                <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                <li>
                  <a href="/terms-and-conditions">Terms and Conditions</a>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h4 className="footer-heading">Experiences</h4>
              <ul className="footer-list">
                <li>
                  <a href={`/art-of-looking-menu/`}>The Art of Looking.</a>
                </li>
                <a href="/tutorial">
                  <li>Tutorial Gallery</li>
                </a>
              </ul>
            </div>
            <div className="footer-col">
              <h4 className="footer-heading">Tools</h4>
              <ul className="footer-list">
                <li className="footer-item-disabled">
                  <a href="#">Values</a>
                </li>
                <li className="footer-item-disabled">
                  <a href="#">Vision</a>
                </li>
                <li className="footer-item-disabled">
                  <a href="#">Ikigai</a>
                </li>
                <li className="footer-item-disabled">
                  <a href="#">Debrief</a>
                </li>
                <li className="footer-item-disabled">
                  <a href="#">Quotes</a>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h4 className="footer-heading">Contact</h4>
              <ul className="footer-list">
                {/* <li>
                  <a
                    data-formkit-toggle="ac5ca39c6b"
                    href="https://nowasteddays.ck.page/ac5ca39c6b"
                  >
                    Sign Up to The NWD Newsletter
                  </a>
                </li> */}
                {/* <li>
                  <hr className="footer--hr"></hr>
                </li> */}
                <li>
                  <a href="/contact">
                    Have an idea? Spotted a bug? Need some help? Send us an
                    email.
                  </a>
                </li>
                <li>
                  <a href="/my-account/faqs">Frequently Asked Questions</a>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h4 className="footer-heading">Feedback</h4>
              <ul className="footer-list">
                <li>
                  <a
                    href="https://form.typeform.com/to/wIfqFYiE"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Less than 10 days logged, complete this 2-minute experience
                    survey
                  </a>
                </li>
                <li>
                  <a
                    href="https://form.typeform.com/to/Jkdxz3gI"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    10 days logged or more, complete 5-minute product survey and
                    get £10.
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <ul className="footer-list footer-social-links">
                <li className="social-icon-item">
                  <a
                    href="https://wa.me/?text=Start%20your%20NoWastedDays%20journal%20today%20for%20free%21%20%3A%20https%3A%2F%2Fnowasteddays.io/register"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </a>
                </li>
                <li className="social-icon-item">
                  <a
                    href="https://www.youtube.com/channel/UCMqVstA-okOwsuZK732k4zQ" // Note: This URL seems incorrect/placeholder
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                </li>
                <li className="social-icon-item">
                  <a
                    href="https://open.spotify.com/show/712AlXapv6PDU6ZAyCPoyq?si=f43c3aecacbd424c"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faSpotify} />
                  </a>
                </li>
                <li className="social-icon-item">
                  <a
                    href="https://podcasts.apple.com/us/podcast/the-nowasteddays-podcast/id1697163760"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faPodcast} />
                  </a>
                </li>
                <li className="social-icon-item">
                  <a
                    href="https://nowasteddaysio.substack.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faBookmark} />
                  </a>
                </li>
                {/* <li className="social-icon-item">
                  <a
                    href="https://bsky.app/profile/nowasteddays.bsky.social"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faBluesky} />
                  </a>
                </li> */}
              </ul>
              <ul className="footer-list">
                <li>
                  <a href="/blog">Blog</a>
                </li>
                <li style={{ marginTop: "12px" }}>
                  <a
                    href="/donate"
                    style={{
                      display: "inline-block",
                      backgroundColor: "#004a22",
                      color: "#e2dfcf",
                      padding: "6px 14px",
                      borderRadius: "20px",
                      fontWeight: "600",
                      // fontSize: "0.85rem",
                      textDecoration: "none",
                    }}
                  >
                    Support NoWastedDays
                  </a>
                </li>
                <li>
                  {userCountError
                    ? `Live Users Updating`
                    : `Live Users: ${userCount}`}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default TestFooter;
